import {
  Avatar, colors, Divider, Drawer, Hidden, Link, List, ListSubheader, Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import avatar from 'src/assets/images/technician.png';
import NavItem from 'src/components/NavItem';
import NavConfig from 'src/layouts/Dashboard/navConfig';
import { getUser } from 'src/utils/Common';
import LiveHelp from '@material-ui/icons/LiveHelp';
import { isProduction } from 'src/utils/contants';
import axios from 'src/utils/axios';

import TechGpt from 'src/components/TechGpt';

import useOnlineStatus from 'src/hooks/useOnlineStatus';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  }
}));

function renderNavItems({
  // eslint-disable-next-line react/prop-types
  items, subheader, key, ...rest
}, klima_teknisyeni) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }, klima_teknisyeni),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc, pathname, item, depth = 0
}, klima_teknisyeni) {
  if (klima_teknisyeni && item.klima_teknisyeni_gizle && item.klima_teknisyeni_gizle) {
    return acc;
  }
  if (item?.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
        disabled={item.disabled}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item?.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
        disabled={item.disabled}
      />
    );
  }

  return acc;
}
let klima_teknisyeni = false;
function NavBar({
  openMobile,
  onMobileClose,
  className,
  ...rest
}) {

  // const onlineStatus = useOnlineStatus();


  const isOnline = useSelector((state) => state.status?.isOnline);
  const isOnlineModeActive = useSelector((state) => state.status?.isOnlineModeActive);

  const classes = useStyles();
  const location = useLocation();

  const SessionUser = getUser();

  const { enqueueSnackbar } = useSnackbar();

  const { t } = useTranslation('common');





  const statusNotificationTrigger = (isOnline) => {

    if (isOnline) {
      enqueueSnackbar(t('lblOnline'), { variant: 'success' });
    }

    else {
      enqueueSnackbar(t('lblOffline'), { variant: 'error' });

    }

  }


  useEffect(() => {
    if (isOnlineModeActive) {
      statusNotificationTrigger(isOnline);
    }
  }, [isOnline, isOnlineModeActive]);


  useEffect(() => {
    if (SessionUser.TechnicianType === undefined) {
      return;
    }
    const user_types = SessionUser.TechnicianType.split(',');
    user_types && user_types.forEach((u) => {
      if (parseInt(u) === 26) {
        klima_teknisyeni = true;
      }
    });
  }, [SessionUser]);

  const [UserImageUrl, setUserImageUrl] = useState(!isProduction ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`);

  const TechnicianImage = `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`;

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // setnavConfig([
    //   {
    //     subheader: 'İşlemler',
    //     items: Menu
    //   }
    // ]);
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    GetSiriusUserImage();
  }, [SessionUser.TechnicianId]);

  const GetSiriusUserImage = () => {
    const config = {
      responseType: 'blob',
    };

    axios.get(`/FileImportExport/SiriusUserImageDetail/${SessionUser.TechnicianId}`, config)
      .then((response) => {
        // openBlob(response.data, dosya.FileName);
        const fileURL = URL.createObjectURL(response.data);
        setUserImageUrl(fileURL);
      }).catch((error) => {

      });


  }

  const navConfig = NavConfig();



  const content = (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <nav className={classes.navigation}>
        {navConfig && navConfig.length > 0 && navConfig.map((list) => renderNavItems({
          items: list.items,
          subheader: list.subheader,
          pathname: location.pathname,
          key: list.subheader
        }, klima_teknisyeni))}
      </nav>
      <Divider className={classes.divider} />
      <div className={classes.profile}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          src={UserImageUrl}
        />
        <div className={classes.details}>
          <Link
            component={RouterLink}
            to="/profile/1/timeline"
            variant="h5"
            color="textPrimary"
            underline="none"
          >
            {`${SessionUser.FirstName} ${SessionUser.LastName}`}
          </Link>
          <Typography variant="body2">
            {SessionUser.ServiceShopCode}
            {' '}
            {SessionUser.ServiceShopName}
            {' '}
            {SessionUser.TopServiceShopName}
          </Typography>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* <TechGpt /> */}
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.mobileDrawer
          }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {navConfig && content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.desktopDrawer
          }}
          open
          variant="persistent"
        >
          {navConfig && content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
